<app-rooms-table class="w-full min-w-600"></app-rooms-table>
